import { parsePhoneNumberFromString } from "libphonenumber-js/mobile";
import type { Country } from "../types/common";

/**
 * The number in international (E.164) format, e.g. "+46701234567".
 *
 * The input may be national ("070-123 45 67"), carry the country code with or
 * without a "+" or "00" ("46701234567", "0046701234567"), or keep the national
 * trunk 0 after the country code ("+460701234567"). A number with another
 * country's code ("+4791234567") keeps that code. Input libphonenumber-js cannot
 * parse is returned without whitespace.
 */
export const toInternationalPhoneNumber = (
  phoneNumber: string,
  country: Country
): string => {
  const parsed = parsePhoneNumberFromString(phoneNumber, country);
  return parsed?.number ?? phoneNumber.replace(/\s+/g, "");
};

/**
 * Whether the number is a mobile number of the given country, in any format a
 * caseworker would type (see toInternationalPhoneNumber). The "mobile" metadata
 * makes landlines invalid, and another country's number is rejected.
 */
export const isPhoneNumberValid = (
  phoneNumber: string,
  country: Country
): boolean => {
  const parsed = parsePhoneNumberFromString(phoneNumber, country);
  return !!parsed && parsed.isValid() && parsed.country === country;
};

export const isEmailValid = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}$/;
  return emailRegex.test(email);
};
